'use client'

import { useRef } from 'react'

import { useViewPromotion } from '../../hooks/useViewPromotion/useViewPromotion'
import type { Promotion } from '../../types/EEC'

type ViewPromotionProps = {
	readonly children: React.ReactNode
	readonly promotions: Promotion[]
	readonly 'data-testid'?: string
	readonly className?: string
}

export const ViewPromotion = ({
	promotions,
	children,
	'data-testid': dataTestId,
	className,
}: ViewPromotionProps) => {
	const ref = useRef(null)
	useViewPromotion({ ref, promotions })

	return (
		<div data-testid={dataTestId} ref={ref} className={className}>
			{children}
		</div>
	)
}
